import { lazy } from 'react';
import { registerModuleRoute } from 'app/navigation/routeRegistry';
import { ModuleRoute } from 'app/navigation/routeRegistry';
import { USER_SCREEN_NAMES } from './navigation/UserNavigation';
export { Settings } from './screens/Settings';
export { useSettingsMenu } from './hooks/useSettingsMenu';
export { useSubscriptionLink } from './hooks/useSubscriptionContent';
export { useLegalContent } from './hooks/useLegalContent';
export { useSupportContent } from './hooks/useSupportContent';
export { MenuSectionRenderer } from './components/MenuSectionRenderer';
export type { IMenuItemConfig, IMenuSection } from './hooks/useSettingsMenu';

const ProfileNavigation = lazy(() => import('./navigation/UserNavigation'));

const profileRoutes: ModuleRoute = {
    id: 'profile',
    Stack: ProfileNavigation,
    meta: {
        placement: 'tab',
        tabLabel: 'Profilo',
        tabIcon: 'setting',
        order: 40,
    },
    screenNames: USER_SCREEN_NAMES,
};


registerModuleRoute(profileRoutes);